import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { FaStar } from "react-icons/fa";
import SidebarMenu from "containers/UserDashboard/SideBarMenu";
import StampsTemplate from "./components/StampTemplate";
import loyaltyApi from "api/loyalty/loyaltyApi";
import { transactions } from "./data/transactions";
import Loading from "components/Loading/Loading";
import { useSelector } from "react-redux";
import { FiCalendar, FiClock, FiRefreshCw, FiTrendingUp } from "react-icons/fi";

export default function LoyaltyCardDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [card, setCard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [transactions, setTransactions] = useState([]);

  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    const fetchCardWithStampCount = async () => {
      try {
        // 1. Get card design info
        const { response: cardRes, err: cardErr } =
          await loyaltyApi.getCardDetail(id);
        if (!cardRes || cardErr) {
          console.error("Card fetch failed:", cardErr);
          setLoading(false);
          return;
        }

        const design = cardRes.data;
        const userTo = user?._id;
        const userFrom = design.writer?._id;

        // 2. Get stamp award progress (stamp count)
        let stampCount = 0;
        try {
          const { response: stampRes } = await loyaltyApi.getStampAwardNumber({
            userFrom,
            userTo,
          });

          if (stampRes?.data?.success) {
            stampCount = stampRes.data.stampAwardNumber;
            setTransactions(stampRes.data.transactions);
          }
        } catch (err) {
          console.error("Failed to fetch stamp count:", err);
        }

        // 3. Set enriched card
        setCard({
          ...design,
          stampCount,
          stampsselected: design.NoofStamps,
        });
      } catch (e) {
        console.error("Unexpected error:", e);
      } finally {
        setLoading(false);
      }
    };

    fetchCardWithStampCount();
  }, [id]);

  const getBonusIndexes = (stampsselected) => {
    if (stampsselected <= 5) return [stampsselected - 1];
    const numBonuses = stampsselected <= 10 ? 2 : stampsselected <= 15 ? 3 : 4;
    return Array.from(
      { length: numBonuses },
      (_, i) => Math.round(((i + 1) / numBonuses) * stampsselected) - 1
    );
  };

  // if (!card) {
  //   return (
  //     <div className="flex items-center justify-center h-[400px] text-lg font-semibold animate-pulse">
  //       <Loading />
  //     </div>
  //   );
  // }

  const bonusIndexes = getBonusIndexes(card?.NoofStamps || 0);
  const upcomingBonusIndex = bonusIndexes.find(
    (idx) => card?.NoOfStamp === idx
  );

  const operatorName = card?.writer?.name || "Unknown";

  const operatorPhoto = card?.writer?.photo || "/default-operator.png";
  console.log({ card });

  const timeAgoWithIcon = (dateString) => {
    const created = new Date(dateString);
    const now = new Date();
    const diffMs = now - created;

    const minutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (years >= 1) {
      return {
        text: `${years} yr${years > 1 ? "s" : ""}`,
        Icon: FiCalendar,
      };
    }

    if (months >= 1) {
      return {
        text: `${months} mth${months > 1 ? "s" : ""} `,
        Icon: FiRefreshCw,
      };
    }

    if (days >= 1) {
      return {
        text: `${days} day${days > 1 ? "s" : ""} `,
        Icon: FiTrendingUp,
      };
    }

    if (hours >= 1) {
      return {
        text: `${hours} hr${hours > 1 ? "s" : ""} `,
        Icon: FiClock,
      };
    }

    if (minutes >= 1) {
      return {
        text: `${minutes} min${minutes > 1 ? "s" : ""} `,
        Icon: FiClock,
      };
    }

    return {
      text: "Now",
      Icon: FiClock,
    };
  };

  return (
    <div className="bg-gray-900 text-white min-h-screen pb-8 pt-12 px-4">
      <div className="container mx-auto px-2">
        <div className="xl:grid grid-cols-8 gap-10 items-start md:py-12 py-0 ">
          <div className="hidden md:block sticky top-16 z-30 col-span-2 bg-gray-800 p-6 rounded-md xl:mb-0 mb-5 max-h-[calc(100vh-4rem)] overflow-y-auto">
            <SidebarMenu />
          </div>
          {loading ? (
            <div className="flex col-span-6 items-center justify-center h-[400px] text-lg font-semibold animate-pulse">
              <Loading />
            </div>
          ) : (
            <div className="col-span-6 rounded-md p-0 md:p-6">
              <button
                onClick={() => navigate("/loyaltywallets")}
                className="flex items-center text-textGray mb-8 text-lg font-medium hover:underline"
              >
                <FiArrowLeft className="mr-1 font-light" size={30} />
              </button>

              <div className="flex flex-col lg:flex-row gap-4">
                {/* Front Card */}
                <div
                  className={`rounded-xl p-5 min-h-[250px] max-w-[400px] flex flex-col justify-between overflow-hidden w-full lg:w-1/2`}
                  style={{
                    backgroundImage: `linear-gradient(to top right, #00000050, ${
                      card.CardColor || "#38BDF8"
                    })`,
                  }}
                >
                  <div className="flex justify-between items-center">
                    <div
                      className="flex items-center gap-2 cursor-pointer"
                      onClick={() => navigate(`/author/${card?.writer?._id}`)}
                    >
                      <img
                        src={operatorPhoto}
                        alt={operatorName}
                        className="w-8 h-8 rounded-full object-cover border border-white"
                      />

                      <h2
                        className="
    font-semibold text-white leading-tight
    max-w-[150px] sm:max-w-[180px]
    line-clamp-2
    text-lg
  "
                        style={{
                          fontSize:
                            operatorName.length > 20 ? "0.9rem" : "1.125rem",
                        }}
                      >
                        {operatorName}
                      </h2>
                    </div>
                    <div className="flex items-center gap-1">
                      <div className="flex items-center gap-2 text-white text-sm">
                        <span>
                          {card.stampCount}/{card.NoofStamps}
                        </span>
                      </div>
                      {upcomingBonusIndex !== undefined && (
                        <div className="bg-redlight text-text text-xs px-2 py-1 rounded-full flex items-center gap-1 shadow-md animate-pulse">
                          <FaStar size={12} />
                          Bonus {bonusIndexes.indexOf(upcomingBonusIndex) + 1}!
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="py-3 flex justify-start">
                    <StampsTemplate
                      stampsselected={card.NoofStamps}
                      stampCount={card.stampCount}
                      pickImg={card.PickImg}
                      pickunImg={card.PickImg}
                      stampedBackground={card.StampColor}
                      unstampedBackground={card.unStampColor}
                      bonusList={[]}
                    />
                  </div>

                  <div className="flex justify-between items-center text-white text-sm">
                    <div>.... {card.writer?._id?.slice(-4)}</div>
                    <div>LOYALTY</div>
                  </div>
                </div>

                {/* Back Card */}
                <div
                  className={`rounded-xl p-5 min-h-[250px] max-w-[400px] flex flex-col justify-between overflow-hidden w-full lg:w-1/2`}
                  style={{
                    backgroundImage: `linear-gradient(to top right, ${card.CardColor}, #0f0f0f)`,
                  }}
                >
                  <div className="space-y-2 text-sm leading-snug overflow-hidden">
                    <p className="text-sm text-white/90">
                      💰 Spend{" "}
                      <span className="font-bold">
                        ${card?.ValueToGetStamp}
                      </span>{" "}
                      per stamp.
                    </p>
                    <p className="font-semibold text-white">
                      🎁 {card.cardDesc4}
                    </p>
                    <p className="text-white/80 text-xs whitespace-pre-line">
                      {card.cardDesc5}
                    </p>
                  </div>

                  <div className="flex justify-between items-center text-xs mt-2">
                    <span className="tracking-wide">
                      Contact:{" "}
                      <span className="font-semibold">
                        {card?.writer?.email}
                      </span>
                    </span>
                    <span className="italic opacity-80">*T&Cs apply</span>
                  </div>
                </div>
              </div>

              <h2 className="text-xl font-semibold mb-4 mt-6">
                Latest Transactions
              </h2>
              <div className="space-y-3">
                {transactions?.length > 0 ? (
                  transactions.map((tx, index) => {
                    const { text, Icon } = timeAgoWithIcon(tx.createdAt);

                    return (
                      <div
                        key={index}
                        className="bg-[#1e1e1e] rounded-lg px-4 py-3"
                      >
                        <div className="flex justify-between items-center font-medium">
                          <span className="text-white">Txn #{index + 1}</span>
                          <div className="flex items-center gap-1 text-gray-400 text-xs">
                            <Icon className="text-white/80" size={14} />
                            <span>{text} ago</span>
                          </div>
                        </div>

                        <div className="text-[12px] text-gray-400 ">
                          Transaction ID:{" "}
                          <span className="text-white">
                            ... {tx._id?.slice(-4)}
                          </span>
                        </div>

                        <div className="text-[12px] text-gray-400">
                          From (Business):{" "}
                          <span className="text-white">
                            {card?.writer?.name}
                          </span>
                        </div>

                        <div className="text-[12px] text-gray-400">
                          To (You):{" "}
                          <span className="text-white">
                            {user?.displayName}
                          </span>
                        </div>
                        <div className="text-xs text-yellow-400 mt-1">
                          +1 stamp{tx.stampreward > 1 && "s"}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-sm text-gray-500">
                    No transactions found.
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import {
//   FaCcVisa,
//   FaUniversity,
//   FaCcMastercard,
//   FaApplePay,
//   FaStar,
// } from "react-icons/fa";
// import { SiAmericanexpress } from "react-icons/si";
// import { sampleCards } from "./data/SampleLoyallyCards";
// import { transactions } from "./data/transactions";
// import SidebarMenu from "containers/UserDashboard/SideBarMenu";
// import StampsTemplate from "./components/StampTemplate";
// import {
//   ChevronDoubleLeftIcon,
//   ChevronLeftIcon,
// } from "@heroicons/react/24/outline";
// import { FiArrowLeft, FiArrowLeftCircle } from "react-icons/fi";
// import RoyaltyCardBack from "containers/Royalty/RoyaltyCardBack";
// import loyaltyApi from "api/loyalty/loyaltyApi";
// import { useSelector } from "react-redux";

// export default function LoyaltyCardDetails() {
//   const { id } = useParams();

//   console.log({ id });
//   const navigate = useNavigate();

//   const user = useSelector((state) => state.auth.user);

//   const [card, setCard] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchCard = async () => {
//       const { response, err } = await loyaltyApi.getCardDetail(id);
//       if (response) setCard(response.data);
//       else console.error(err);
//       setLoading(false);
//     };

//     fetchCard();
//   }, [id]);

//   console.log({ card });

//   const filteredTx = transactions.filter((tx) => tx.cardId === id);

//   if (!card) {
//     return (
//       <div className="text-white text-center py-10 text-xl">
//         Card not found.
//       </div>
//     );
//   }

//   const getBonusIndexes = (stampsselected) => {
//     if (stampsselected <= 5) return [stampsselected - 1];
//     const numBonuses = stampsselected <= 10 ? 2 : stampsselected <= 15 ? 3 : 4;
//     return Array.from(
//       { length: numBonuses },
//       (_, i) => Math.round(((i + 1) / numBonuses) * stampsselected) - 1
//     );
//   };

//   const bonusIndexes = getBonusIndexes(card.stampsselected);
//   const upcomingBonusIndex = bonusIndexes.find(
//     (idx) => card.stampCount === idx
//   );

//   const extendedCard = {
//     rewardDetails:
//       card.cardDesc4 ||
//       "Get $10 off your next purchase after collecting all stamps.",
//     terms:
//       card.cardDesc5 ||
//       "No partial redemptions. Stamps cannot be exchanged or redeemed for cash.",
//     contactInfo: card.cardDesc3 || "Unknown Store",
//     cardColor: card.CardColor || "#FFC70B",
//   };

//   return (
//     <div className="bg-gray-900 text-white min-h-screen pb-8 pt-12 px-4">
//       <div className="container mx-auto px-2">
//         <div className="xl:grid grid-cols-8 gap-10 items-start md:py-12 py-0 ">
//           <div className="hidden md:block sticky top-16 z-30 col-span-2 bg-gray-800 p-6 rounded-md xl:mb-0 mb-5 max-h-[calc(100vh-4rem)] overflow-y-auto">
//             <SidebarMenu />
//           </div>
//           <div className="col-span-6 rounded-md  p-0 md:p-6">
//             <button
//               onClick={() =>
//                 navigate("/loyaltywallets", { state: { status: card?.status } })
//               }
//               className="flex items-center text-textGray mb-8 text-lg font-medium mb-2 hover:underline"
//             >
//               {/* Option 1: SVG icon */}
//               <FiArrowLeft className="mr-1 font-light" size={40} />
//             </button>

//             <div className="flex flex-col lg:flex-row gap-4">
//               {/* Front Card */}
//               <div
//                 className={`rounded-xl p-5 min-h-[250px] max-w-[400px]  flex flex-col justify-between overflow-hidden w-full lg:w-1/2 ${card.color}`}
//               >
//                 {/* Header */}
//                 <div className="flex justify-between items-center">
//                   <div className="flex items-center gap-2">
//                     <div className="text-white text-2xl">{card.logo}</div>
//                     <h2 className="text-lg font-semibold text-white whitespace-nowrap">
//                       {card.brand}
//                     </h2>
//                   </div>

//                   <div className="flex items-center gap-1">
//                     <div className="flex items-center gap-2 text-white text-sm">
//                       <span>
//                         {card.stampCount}/{card.stampsselected}
//                       </span>
//                       {upcomingBonusIndex === undefined && (
//                         <span className="uppercase">{card.type}</span>
//                       )}
//                     </div>
//                     {upcomingBonusIndex !== undefined && (
//                       <div className="bg-redlight text-text text-xs px-2 py-1 rounded-full flex items-center gap-1 shadow-md animate-pulse">
//                         <FaStar size={12} />
//                         Bonus {bonusIndexes.indexOf(upcomingBonusIndex) + 1}!
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* Stamps */}
//                 <div className="py-3 flex justify-start">
//                   <StampsTemplate
//                     stampsselected={card.stampsselected}
//                     stampCount={card.stampCount}
//                     pickImg={"/static/media/coffee.0072c842.PNG"}
//                     pickunImg={"/static/media/coffee.0072c842.PNG"}
//                     stampedBackground={"#FFF"}
//                     unstampedBackground={"#FFF"}
//                     bonusList={card.bonuses}
//                   />
//                 </div>

//                 {/* Footer */}
//                 <div className="flex justify-between items-center text-white">
//                   <div className="text-sm tracking-widest">
//                     .... {card.last4}
//                   </div>
//                   <div>{card.icon}</div>
//                 </div>
//               </div>

//               {/* Back Card */}
//               <div
//                 className={`rounded-xl p-5 h-[250px] max-w-[400px] flex flex-col justify-between overflow-hidden w-full lg:w-1/2 text-white ${card.color}`}
//               >
//                 <div className="space-y-2 text-sm leading-snug overflow-hidden">
//                   <p className="font-semibold text-white">
//                     🎁 {extendedCard.rewardDetails}
//                   </p>
//                   <p className="text-white/80 text-xs whitespace-pre-line">
//                     {extendedCard.terms}
//                   </p>
//                 </div>

//                 <div className="flex justify-between items-center text-xs mt-2">
//                   <span className="tracking-wide">
//                     Contact: {extendedCard.contactInfo}
//                   </span>
//                   <span className="italic opacity-80">*T&Cs apply</span>
//                 </div>
//               </div>
//             </div>

//             <h2 className="text-xl font-semibold mb-4 mt-6">
//               Latest Transactions
//             </h2>
//             <div className="space-y-3">
//               {filteredTx.length > 0 ? (
//                 filteredTx.map((tx, index) => (
//                   <div
//                     key={index}
//                     className="bg-[#1e1e1e] rounded-lg px-4 py-3"
//                   >
//                     <div className="flex justify-between font-medium">
//                       <span>{tx.merchant}</span>
//                       <span>{tx.amount}</span>
//                     </div>
//                     <div className="text-sm text-gray-400">{tx.method}</div>
//                     {tx.date && (
//                       <div className="text-xs text-gray-500">{tx.date}</div>
//                     )}
//                     {tx.stampreward && (
//                       <>
//                         <div className="text-xs text-yellow-400 mt-1">
//                           +{tx.stampreward} stamp{tx.stampreward > 1 && "s"}
//                         </div>
//                         <div className="text-[10px] text-gray-400"></div>
//                       </>
//                     )}
//                   </div>
//                 ))
//               ) : (
//                 <div className="text-sm text-gray-500">
//                   No transactions found.
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
